"use client";
// @ts-strict-ignore
import * as React from "react";
import styled from "styled-components";
import { StyledTable } from "../style";

const StyleContainer = styled(StyledTable)`
  overflow-x: scroll;
  text-align: center;
  margin-bottom: 30px;

  th {
    padding: 20px 12px 20px 0;
  }
  tbody {
    td {
      font-size: 14px;
    }
  }
`;

const ContentfulTable = ({ children }) => (
  <StyleContainer>
    <table>{children}</table>
  </StyleContainer>
);

export default ContentfulTable;
